import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Sınıf birleştirme. tailwind-merge tasarım sisteminin ölçeklerini bilir: `text-h1` (yazı boyu) ile
 * `text-fg` (renk) çakışmaz; özel yardımcılar (`h-control`, `border-strong`, `z-dialog`…) doğru gruptadır.
 */
const merge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display', 'kpi', 'h1', 'h2', 'h3', 'body', 'body-sm', 'caption', 'micro'],
      radius: ['sm', 'md', 'lg', 'xl'],
      shadow: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    classGroups: {
      'border-color': ['border-strong', 'border-subtle'],
      h: ['h-control', 'h-row'],
      'min-h': ['min-h-control'],
      px: ['px-cell'],
      p: ['p-card'],
      size: ['size-control', 'size-grid-cell'],
      z: ['z-sticky', 'z-dropdown', 'z-dropdown-sheet', 'z-dropdown-dialog', 'z-sheet', 'z-dialog', 'z-toast', 'z-palette'],
      duration: ['duration-fast', 'duration-base', 'duration-slow'],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
